import api from "api"

const feedback = {
    create: (payload) => {
        return api().post('/users/wishlists', payload)
    }
}

export default feedback;